document.addEventListener('DOMContentLoaded', function () {
  var selectors = {
    mediaWrapper: '.grid__item.product__media-wrapper',
    submitButton: '.product-form__submit',
    productFormButtons: '.product-form__buttons',
    addonInput: '.product-addon-card__input',
    variantInput: '.product-variant-id',
    quantityInput: '.new-quantity-input-wp',
    spinner: '.product-form__buttons .loading__spinner',
    cartDrawer: '.cart-drawer-outer',
    cartDrawerElement: 'cart-drawer',
    cartIcon: '.header__icon--cart',
    techBuyLink: '.tech-btn-outer a, .tech-btn-outer-2 a'
  };

  var mediaWrapper = document.querySelector(selectors.mediaWrapper);
  var submitButton = document.querySelector(selectors.submitButton);
  var productFormButtons = document.querySelector(selectors.productFormButtons);
  var addonInputs = Array.from(document.querySelectorAll(selectors.addonInput));

  function stripTrailingZeroPrices(scope) {
    var pricePattern = /((?:US)?\$\s?\d[\d,]*)\.00\b/g;
    var priceNodes = (scope || document).querySelectorAll(
      '.price, .price-item, .product-option, .cart-item__price-wrapper, [class*="price"]'
    );

    priceNodes.forEach(function (node) {
      node.childNodes.forEach(function (child) {
        if (child.nodeType === Node.TEXT_NODE) {
          var cleanText = child.textContent.replace(pricePattern, '$1');

          if (cleanText !== child.textContent) {
            child.textContent = cleanText;
          }
        }
      });
    });
  }

  function suppressLegacyOptionApps() {
    if (addonInputs.length === 0) {
      return;
    }

    document
      .querySelectorAll('[id*="globo_product_options"], .gpo-container, .gpo-app, .gpo-form')
      .forEach(function (element) {
        var appBlock = element.closest('[id^="shopify-block-"]') || element;

        appBlock.setAttribute('hidden', 'hidden');
        appBlock.style.display = 'none';
      });
  }

  function setLoading(isLoading) {
    var spinner = document.querySelector(selectors.spinner);

    if (spinner) {
      spinner.classList.toggle('hidden', !isLoading);
    }

    if (productFormButtons) {
      productFormButtons.classList.toggle('button-hide', isLoading);
    }
  }

  function getSelectedItems() {
    var variantInput = document.querySelector(selectors.variantInput);
    var quantityInput = document.querySelector(selectors.quantityInput);

    if (!variantInput) {
      return [];
    }

    var items = [
      {
        id: variantInput.value,
        quantity: quantityInput ? Number(quantityInput.value || 1) : 1
      }
    ];

    addonInputs.forEach(function (input) {
      if (input.checked && !input.disabled) {
        items.push({
          id: input.value,
          quantity: 1
        });
      }
    });

    return items;
  }

  function refreshCartDrawer(parsedState) {
    var nativeCartDrawer = document.querySelector(selectors.cartDrawerElement);

    if (
      nativeCartDrawer &&
      parsedState &&
      parsedState.sections &&
      typeof nativeCartDrawer.renderContents === 'function'
    ) {
      if (typeof parsedState.item_count === 'number') {
        nativeCartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      nativeCartDrawer.renderContents(parsedState);
      stripTrailingZeroPrices(nativeCartDrawer);
      return Promise.resolve();
    }

    return fetch('/cart')
      .then(function (response) {
        return response.text();
      })
      .then(function (cartData) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(cartData, 'text/html');
        var cartDrawer = doc.querySelector(selectors.cartDrawer);
        var cartCountIcon = doc.querySelector(selectors.cartIcon);
        var currentCartDrawer = document.querySelector(selectors.cartDrawer);
        var currentCartCountIcon = document.querySelector(selectors.cartIcon);

        if (cartDrawer && currentCartDrawer) {
          currentCartDrawer.innerHTML = cartDrawer.innerHTML;
          var drawer = currentCartDrawer.querySelector(selectors.cartDrawerElement);

          if (drawer) {
            drawer.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        }

        if (cartCountIcon && currentCartCountIcon) {
          currentCartCountIcon.innerHTML = cartCountIcon.innerHTML;
        }

        stripTrailingZeroPrices(currentCartDrawer || document);
      });
  }

  stripTrailingZeroPrices(document);

  var priceFormatQueued = false;
  var priceObserver = new MutationObserver(function () {
    if (priceFormatQueued) {
      return;
    }

    priceFormatQueued = true;
    window.requestAnimationFrame(function () {
      stripTrailingZeroPrices(document);
      priceFormatQueued = false;
    });
  });

  priceObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  if (addonInputs.length > 0) {
    suppressLegacyOptionApps();

    var legacyOptionObserver = new MutationObserver(suppressLegacyOptionApps);
    legacyOptionObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var cartVariantIds = cart.items.map(function (item) {
          return String(item.variant_id);
        });

        addonInputs.forEach(function (input) {
          var alreadyInCart = cartVariantIds.includes(input.value);

          if (alreadyInCart) {
            input.checked = false;
            input.disabled = true;
            input.closest('.product-addon-card').classList.add('is-in-cart');
          }
        });
      })
      .catch(function (error) {
        console.error('Error checking add-ons in cart:', error);
      });
  }

  if (submitButton && mediaWrapper && addonInputs.length > 0) {
    submitButton.addEventListener('click', function (e) {
      if (submitButton.disabled) {
        return;
      }

      e.preventDefault();

      var items = getSelectedItems();

      if (items.length === 0) {
        return;
      }

      setLoading(true);

      var cartDrawer = document.querySelector(selectors.cartDrawerElement);
      var cartSections = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map(function (section) {
            return section.id;
          })
        : ['cart-drawer', 'cart-icon-bubble'];

      if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: items,
          sections: cartSections,
          sections_url: window.location.pathname
        })
      })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Cart add failed');
          }
          return response.json();
        })
        .then(function (response) {
          return refreshCartDrawer(response);
        })
        .catch(function (error) {
          console.error('Error adding products to cart:', error);
        })
        .finally(function () {
          setLoading(false);
        });
    });
  }

  document.querySelectorAll(selectors.techBuyLink).forEach(function (link) {
    link.addEventListener('click', function (e) {
      var productFormButton = document.querySelector(selectors.submitButton);

      if (productFormButton) {
        e.preventDefault();
        productFormButton.click();
      }
    });
  });
});
